import { useAppStore } from "../store/appStore"
import { Alert, Snackbar, SnackbarOrigin } from "@mui/material"

export const SnackFeedback = () => {

  const snackText = useAppStore(state => state.snackText)
  const setSnackText = useAppStore(state => state.setSnackText)
  const open = snackText !== "" ? true : false
  const handleClose = () => {
    setSnackText("")
  }
  const origin: SnackbarOrigin = {
    horizontal: 'center',
    vertical: 'bottom'
  }

  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={handleClose}
      anchorOrigin={ origin }
    >
      <Alert onClose={handleClose} severity="success" sx={{ width: '100%', p: 1 }}>
        {snackText}
      </Alert>
    </Snackbar>
  )
}